module.exports = __webpack_public_path__ + "img/hr-tree-09-d-leaves.19600fe8.png";